import { render, staticRenderFns } from "./ArticleManage.vue?vue&type=template&id=30daad50&scoped=true&"
import script from "./ArticleManage.js?vue&type=script&lang=js&"
export * from "./ArticleManage.js?vue&type=script&lang=js&"
import style0 from "./ArticleManage.vue?vue&type=style&index=0&id=30daad50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30daad50",
  null
  
)

export default component.exports